import { render, staticRenderFns } from "./addSupplierDelivery.vue?vue&type=template&id=3680249c&scoped=true"
import script from "./addSupplierDelivery.vue?vue&type=script&lang=js"
export * from "./addSupplierDelivery.vue?vue&type=script&lang=js"
import style0 from "./addSupplierDelivery.vue?vue&type=style&index=0&id=3680249c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3680249c",
  null
  
)

export default component.exports